import _createClass from "E:\\FIVER310-everestcoin\\mintsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _classCallCheck from "E:\\FIVER310-everestcoin\\mintsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _inherits from "E:\\FIVER310-everestcoin\\mintsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _createSuper from "E:\\FIVER310-everestcoin\\mintsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createSuper";
import _wrapNativeSuper from "E:\\FIVER310-everestcoin\\mintsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/wrapNativeSuper";
export var ProviderRpcError = /*#__PURE__*/function (_Error) {
  _inherits(ProviderRpcError, _Error);
  var _super = _createSuper(ProviderRpcError);
  function ProviderRpcError(error) {
    var _this;
    _classCallCheck(this, ProviderRpcError);
    _this = _super.call(this, error.message);
    _this.message = error.message;
    _this.code = error.code;
    _this.data = error.data;
    return _this;
  }
  return _createClass(ProviderRpcError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
export var defaultWalletUnavailableMsg = function defaultWalletUnavailableMsg(_ref) {
  var label = _ref.label;
  return "Please install or enable ".concat(label, " to continue");
};
export var isWalletAvailable = function isWalletAvailable(provider, checkProviderIdentity, device) {
  var _a;
  // No injected providers exist.
  if (!provider) {
    return false;
  }
  // Many injected providers add their own object into window.
  if (checkProviderIdentity({
    provider: provider,
    device: device
  })) {
    return true;
  }
  // For multiple injected providers, check providers array
  // example coinbase inj wallet pushes over-ridden wallets
  // into a providers array at window.ethereum
  return !!((_a = provider.providers) === null || _a === void 0 ? void 0 : _a.some(function (provider) {
    return checkProviderIdentity({
      provider: provider,
      device: device
    });
  }));
};